module.exports = __webpack_public_path__ + "static/media/as6sj.2e1bb33c.png";